import type { AuthErrorCode } from '@flarecode/shared';
import { ApiError } from './api';

const MESSAGES: Record<AuthErrorCode, string> = {
  invalid_email: 'Please enter a valid email address.',
  invalid_username:
    'Username must be 3–20 characters, lowercase letters, digits, underscore, or hyphen, and cannot start/end with a special character.',
  weak_password: 'Password must be at least 8 characters.',
  password_too_long: 'Password is too long (max 128 characters).',
  missing_credentials: 'Please enter your credentials.',
  email_taken: 'That email is already registered. Try signing in instead.',
  username_taken: 'That username is already taken.',
  invalid_credentials: "Email/username or password didn't match.",
  unauthorized: 'You need to be signed in for that.',
  rate_limited: "You're going a little too fast. Wait a minute and try again.",
};

/**
 * Translate any error thrown by the API client into a user-friendly message.
 * Falls back to a generic message for unknown errors or network failures.
 */
export function authErrorMessage(err: unknown): string {
  if (err instanceof ApiError) {
    if (err.code && err.code in MESSAGES) {
      return MESSAGES[err.code as AuthErrorCode];
    }
    if (err.status === 0 || err.status >= 500) {
      return 'Something went wrong on our end. Please try again in a moment.';
    }
    return err.message || 'Request failed.';
  }
  return 'Network error. Check your connection and try again.';
}
